import React, { useState } from 'react';
import { Form, Field } from 'react-final-form';

import Select from 'react-select';
import { useEffect } from 'react';
import { store } from '../../../../../store';
import { ButtonTable } from '../../../../global/Styles/buttons';
import { inputsSettingsTrue, inputsSettingsFalse, inputTextAreaTrue, inputTextAreaFalse } from '../../../../global/Styles/inputs';
import { useApiClient, validateSuccess2xx } from '../../../../../clients/apiAuth';
import { ModalTitle } from '../../../../global/Styles/titles';
import Skeleton from 'react-loading-skeleton';
import { moneyFormat } from '../../../../../utils/format';
import FormStateToRedux from '../../../RFF/FormStateToRedux';

export const ModalTarifa = (props) => {
  const { selSolicitudVehiculoTipo } = props.data;
  const { createSolicitudDetalle } = props.endPoints;

  const storeState = store.getState();

  const contratoID = storeState.Solicitud?.selSolicitud.CONTRATO_ID;
  const solicitudFecha = storeState.Solicitud?.selSolicitud.SOLICITUD_FECHA;

  const { get } = useApiClient();

  const [tarifaOptions, setTarifaOptions] = useState([]);
  const [tarifaUnidadOptions, setTarifaUnidadOptions] = useState([]);

  const [canChangeValue, setCanChangeValue] = useState(false);

  const editMode = storeState.AsignarBono.selAsignarBono === null ? false : true;

  const proxyTask = async (form) => {
    const withAllValues = {
      ...form,
      TERCERO_AUDITORIA: storeState.auth.data.user.TERCERO_ID,
      SOLICITUD_VEHICULO_TIPO_ID: selSolicitudVehiculoTipo.SOLICITUD_VEHICULO_TIPO_ID,
    };

    if (editMode) {
      // updateAsignarBono(storeState.AsignarBono.selAsignarBono.SOLICITUD_BONO_ID, form);
    } else {
      createSolicitudDetalle(withAllValues);
    }
  };

  const getTarifaUnidadOptions = async () => {
    const result = await get(`/tarifaUnidad?CONTRATO_ID=${contratoID}`);

    if (!validateSuccess2xx(result)) {
      const lst = result.data.map((row) => ({
        label: `Sin unidades`,
        value: 0,
      }));

      setTarifaUnidadOptions(lst);
    }

    const lst = result.data.map((row) => ({
      label: `${row.TARIFA_UNIDAD}`,
      value: row.TARIFA_UNIDAD,
    }));

    setTarifaUnidadOptions(lst);
  };

  const validate = (values) => {
    const errors = {};
    //  'SOLICITUD_BONO_CAUSADO' SOLICITUD_BONO_VALOR
    const requiredFields = ['SOLICITUD_BONO_FECHA', 'TARIFA_ID', 'SOLICITUD_BONO_OBSERVACION', 'SOLICITUD_DETALLE_CANTIDAD'];
    requiredFields.forEach((field) => {
      if (!values[field]) {
        errors[field] = 'Requerido';
      }
    });

    return errors;
  };

  const loadTarifaOptions = async (filterUnidad) => {
    try {
      setTarifaOptions([]);
      const result = await get(`/tarifa?TARIFA_UNIDAD=${filterUnidad}&VEHICULO_TIPO_ID=${selSolicitudVehiculoTipo.VEHICULO_TIPO_ID}&CONTRATO_ID=${contratoID}`);

      // if (!validateSuccess2xx(result)) return CustomToast({ result });

      const lst = result.data.map((row) => ({
        label: `${row.TARIFA_ITEM} : ${row.TARIFA_GRUPO} ${row.TARIFA_NOMBRE} ${moneyFormat(row.TARIFA_VALOR)}`,
        value: row.TARIFA_ID,
        price: row.TARIFA_VALOR,
      }));

      setTarifaOptions(lst);
    } catch (error) {
      // ErrorToast('Error:', error);
    }
  };

  const setTARIFA_UNIDAD = (args, state, { setIn, changeValue }) => {
    const field = state.fields['TARIFA_UNIDAD'];
    field.change(args[0].value);

    loadTarifaOptions(args[0].value);
  };

  const setTARIFA_ID = (args, state, { setIn, changeValue }) => {
    const field = state.fields['TARIFA_ID'];
    const fieldValor = state.fields['SOLICITUD_DETALLE_VALOR'];
    field.change(args[0].value);
    fieldValor.change(args[0].price);

    setCanChangeValue(false);

    if (Number(args[0].price) === 0) {
      setCanChangeValue(true);
    }
  };

  const setSOLICITUD_DETALLE_CANTIDAD = (args, state, { setIn, changeValue }) => {
    const field = state.fields['SOLICITUD_DETALLE_CANTIDAD'];
    const fieldValor = state.fields['SOLICITUD_DETALLE_VALOR'];

    const fieldTotal = state.fields['SOLICITUD_DETALLE_TOTAL'];

    field.change(args[0].target.value);

    fieldTotal.change(args[0].target.value * fieldValor.lastFieldState.value);
  };

  const setSOLICITUD_DETALLE_VALOR = (args, state, { setIn, changeValue }) => {
    const field = state.fields['SOLICITUD_DETALLE_VALOR'];
    const fieldCantidad = state.fields['SOLICITUD_DETALLE_CANTIDAD'];

    const fieldTotal = state.fields['SOLICITUD_DETALLE_TOTAL'];

    field.change(args[0].target.value);

    fieldTotal.change(args[0].target.value * fieldCantidad.lastFieldState.value);
  };

  const handleCloseModal = () => {
    props.modals.handleShowTarifaModal(false);
    //store.dispatch(setAsignarSelBonoInit());
  };

  useEffect(() => {
    getTarifaUnidadOptions();
  }, [contratoID]);

  return (
    <div
      className="min-w-screen animated fadeIn faster outline-none  focus:outline-none  fixed inset-0 left-0 top-0 z-50 flex h-screen items-center justify-center overflow-y-scroll bg-cover bg-center bg-no-repeat"
      id="modal-id">
      <div className="fixed inset-0 z-0 bg-black opacity-50"></div>
      <div className="relative mx-auto my-auto w-full max-w-2xl rounded-xl bg-white p-5  shadow-lg ">
        <ModalTitle>{editMode ? 'EDITAR' : 'NUEVO'} SERVICIO ITEM</ModalTitle>
        <Form
          onSubmit={proxyTask}
          validate={editMode ? null : validate}
          initialValues={
            editMode
              ? { ...storeState.AsignarBono.selAsignarBono }
              : {
                  VEHICULO_TIPO_DESCRIPCION: selSolicitudVehiculoTipo.VEHICULO_TIPO_DESCRIPCION,
                  VEHICULO_TIPO_ID: selSolicitudVehiculoTipo.VEHICULO_TIPO_ID,
                  SOLICITUD_BONO_FECHA: new Date(solicitudFecha).toISOString().split('T')[0],
                }
          }
          mutators={{
            setTARIFA_UNIDAD,
            setTARIFA_ID,
            setSOLICITUD_DETALLE_CANTIDAD,
            setSOLICITUD_DETALLE_VALOR,
          }}
          subscription={{ submitting: true, pristine: true }}>
          {({ handleSubmit, form, submitting, pristine }) => (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form="frmAddTarifa" />
              <div className="">
                <div className="flex-auto justify-center p-5 text-left">
                  <div className="flex space-x-4">
                    <div className="mt-1 w-1/2"></div>
                    <div className="mt-1 w-1/2">
                      <Field name="SOLICITUD_BONO_FECHA">
                        {({ input, meta }) => (
                          <>
                            <p className="text-sm text-gray-800">Fecha</p>
                            <input
                              {...input}
                              type="date"
                              placeholder="Fecha"
                              className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                            />
                            {/* PENDIENTE PARA AGREGAR TOOLTIPS CON LOS ERRORES */}
                          </>
                        )}
                      </Field>
                    </div>
                  </div>

                  <div className="flex space-x-4">
                    <div className="mt-1 w-1/2">
                      <Field name="VEHICULO_TIPO_DESCRIPCION">
                        {({ input, meta }) => (
                          <>
                            <p className="text-sm text-gray-800">Tipo de vehículo</p>
                            <input
                              {...input}
                              type="text"
                              className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                            />
                            {/* PENDIENTE PARA AGREGAR TOOLTIPS CON LOS ERRORES */}
                          </>
                        )}
                      </Field>
                    </div>
                    <div className="mt-1 flex w-1/2 flex-col">
                      <p className="text-sm text-gray-800">Unidad</p>
                      <Field name="TARIFA_UNIDAD">
                        {({ input, meta }) => (
                          <>
                            {tarifaUnidadOptions && (
                              <Select
                                options={tarifaUnidadOptions}
                                // defaultValue={tarifaUnidadOptions[0]}
                                name="selectTarifaUnidadOptions"
                                onChange={form.mutators.setTARIFA_UNIDAD}
                                styles={{
                                  control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    marginTop: 6,
                                    borderColor: meta.error && meta.touched ? 'red' : null,
                                  }),
                                }}
                              />
                            )}
                            <input
                              {...input}
                              type="hidden"
                            />
                          </>
                        )}
                      </Field>
                    </div>
                  </div>

                  <div className="flex flex-col ">
                    <p className="text-sm text-gray-800">Tarifa</p>

                    <Field name="TARIFA_ID">
                      {({ input, meta }) => (
                        <>
                          {tarifaOptions && (
                            <Select
                              options={tarifaOptions}
                              // defaultValue={tarifaOptions[0]}
                              name="selectTarifaUnidadOptions"
                              onChange={form.mutators.setTARIFA_ID}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  marginTop: 6,
                                  borderColor: meta.error && meta.touched ? 'red' : null,
                                }),
                              }}
                            />
                          )}
                          <input
                            {...input}
                            type="hidden"
                          />
                        </>
                      )}
                    </Field>
                  </div>

                  <div className="flex space-x-4">
                    <div className="mt-1 w-1/3">
                      <Field name="SOLICITUD_DETALLE_CANTIDAD">
                        {({ input, meta }) => (
                          <>
                            <p className="text-sm text-gray-800">Cantidad</p>
                            <input
                              {...input}
                              type="number"
                              placeholder="Cantidad"
                              onChange={form.mutators.setSOLICITUD_DETALLE_CANTIDAD}
                              className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                            />
                            {/* PENDIENTE PARA AGREGAR TOOLTIPS CON LOS ERRORES */}
                          </>
                        )}
                      </Field>
                    </div>
                    <div className="mt-1 w-1/3">
                      <Field name="SOLICITUD_DETALLE_VALOR">
                        {({ input, meta }) => (
                          <>
                            <p className="text-sm text-gray-800">Valor</p>
                            <input
                              {...input}
                              type="number"
                              placeholder="Valor"
                              readOnly={!canChangeValue}
                              onChange={form.mutators.setSOLICITUD_DETALLE_VALOR}
                              className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                            />
                            {/* PENDIENTE PARA AGREGAR TOOLTIPS CON LOS ERRORES */}
                          </>
                        )}
                      </Field>
                    </div>
                    <div className="mt-1 w-1/3">
                      <Field name="SOLICITUD_DETALLE_TOTAL">
                        {({ input, meta }) => (
                          <>
                            <p className="text-sm text-gray-800">Total</p>
                            <input
                              {...input}
                              readOnly
                              type="number"
                              placeholder="Total"
                              className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                            />
                            {/* PENDIENTE PARA AGREGAR TOOLTIPS CON LOS ERRORES */}
                          </>
                        )}
                      </Field>
                    </div>
                  </div>

                  <Field name="SOLICITUD_BONO_OBSERVACION">
                    {({ input, meta }) => (
                      <>
                        <p className="text-sm text-gray-800">Observación</p>
                        <textarea
                          {...input}
                          rows={6}
                          className={meta.error && meta.touched ? `${inputTextAreaFalse}` : `${inputTextAreaTrue} `}
                        />
                        {/* PENDIENTE PARA AGREGAR TOOLTIPS CON LOS ERRORES */}
                      </>
                    )}
                  </Field>
                </div>
                <div className="md:block mx-16 mt-2 space-x-4 text-center">
                  <ButtonTable onClick={() => handleCloseModal()}>Cancelar</ButtonTable>
                  {/* disabled={submitting || pristine} */}
                  <ButtonTable type="submit">{editMode ? 'Actualizar' : 'Agregar'}</ButtonTable>
                </div>
              </div>
            </form>
          )}
        </Form>
      </div>
    </div>
  );
};
